import { jsx as z } from "@emotion/react/jsx-runtime";
import { useContext as J, createContext as K, useState as c, useEffect as O, useMemo as Q } from "react";
import { useSearch as U } from "./hooks/useSearch.js";
import { useSelect as Z } from "./hooks/useSelect.js";
import { TEXT_AREA_HEIGHT as $ } from "../../TextArea/TextArea.styled.js";
import { mergeCreatableProps as ee } from "../utils/mergeCreatableProps.js";
import { useSuggestion as te } from "./hooks/useSuggestion.js";
import { SuggestionVisibility as oe } from "../../../types/components/select.js";
import { MenuListVariantEnum as se } from "../../../types/components/menuList.js";
const w = K(void 0), fe = () => {
  const s = J(w);
  if (!s)
    throw new Error("useMultiSelectContext must be used within a MultiSelectProvider");
  return s;
}, pe = ({
  children: s,
  selectedValue: r,
  sections: a,
  disabled: p = !1,
  readOnly: S = !1,
  required: I = !1,
  error: _ = !1,
  warning: F = !1,
  success: H = !1,
  variantTags: L = "primary",
  onChange: i,
  onSearch: u,
  emptyMessage: V,
  selectableCardChildren: y,
  disableReset: l = !1,
  creatableProps: g,
  variant: R = se.SelectableCard,
  customSectionLabel: j,
  customSectionColor: B,
  position: D = "bottom",
  maxSelected: G,
  ignoreSearchFilter: N = !1,
  ...C
}) => {
  const [d, m] = c(!1), [P, v] = c([]), [f, n] = c(a), [x, M] = c($), W = {
    suggestionProps: {
      overrideAddCreatedSection: ({
        searchValue: e
      }) => () => i([...r, {
        label: e,
        value: e,
        name: e
      }]),
      suggestionVisibility: oe.VISIBLE_WHEN_TYPED
    },
    isMenuListVisible: !0
  };
  O(() => {
    n(a);
  }, [a]);
  const E = ee({
    defaultCreatableProps: W,
    creatableProps: g
  }), X = () => {
    const e = {
      label: o,
      value: o,
      name: o
    };
    n((q) => [...q, {
      options: [e]
    }]), i([...r, e]), t.handleResetSearchField();
  }, t = U({
    onSearch: u,
    disableReset: l,
    showMenu: d
  }), o = t.searchValue.trim(), b = g?.suggestionProps?.overrideAddCreatedSection, h = b ? b({
    searchValue: o,
    setSections: n,
    setCreatedSections: v,
    handleResetSearchField: t.handleResetSearchField
  }) : X, A = te({
    searchValue: o,
    sections: [...f, ...P],
    suggestionProps: E?.suggestionProps
  }), T = Z({
    disabled: p,
    readOnly: S,
    setShowMenu: m
  }), Y = {
    ...T,
    ...t,
    ...A
  }, k = Q(() => ({
    selectedValue: r,
    sections: f,
    setSections: n,
    createdSections: P,
    setCreatedSections: v,
    disabled: p,
    readOnly: S,
    required: I,
    error: _,
    warning: F,
    success: H,
    variantTags: L,
    onChange: i,
    onSearch: u,
    emptyMessage: V,
    selectableCardChildren: y,
    disableReset: l,
    creatableProps: E,
    addCreatedSection: h,
    showMenu: d,
    setShowMenu: m,
    variant: R,
    customSectionLabel: j,
    customSectionColor: B,
    position: D,
    maxSelected: G,
    ignoreSearchFilter: N,
    offsetTextInput: x,
    setOffsetTextInput: M,
    ...C,
    ...Y
  }), [C, r, f, i, u, l, t, T, A, h, d, m, x, M]);
  return /* @__PURE__ */ z(w.Provider, { value: k, children: s });
};
export {
  w as MultiSelectContext,
  pe as MultiSelectProvider,
  fe as useMultiSelectContext
};
